import React from 'react';

const AboutHero: React.FC = () => {
  return (
    <section
      className="about-hero"
      style={{
        background:
          "linear-gradient(120deg,#002D5C 70%,rgba(0,102,204,0.8) 100%), url('/images/hkust/hero-campus.jpg') center/cover no-repeat",
        color: 'white',
        minHeight: '340px',
        padding: '140px 0 80px',
        position: 'relative'
      }}
    >
      <div className="container position-relative" style={{ zIndex: 2 }}>
      </div>
      <div
        style={{
          position: 'absolute',
          inset: 0,
          background: 'linear-gradient(120deg,rgba(0,29,67,.63) 60%,rgba(0,102,204,0.58) 100%)',
          zIndex: 1
        }}
      ></div>
    </section>
  );
};

export default AboutHero;

